import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import PricingTable from "@knowit-alma/common/src/components/molecules/PricingTable/PricingTable"

import styles from "./PricingTables.module.scss"

const PricingTables = ({ table = [] }) => {
  const tableFormatted = table.map((item, index) => {
    const colsXl =
      table.length === 4
        ? { span: 3 }
        : table.length === 3
        ? { span: 4 }
        : { span: 6 }
    const colsLg = table.length === 3 ? { span: 4 } : { span: 6 }
    return (
      <Col lg={colsLg} xl={colsXl} key={index} className={styles.col}>
        <PricingTable
          {...item}
          variant={table.length === 4 ? "small" : "regular"}
        />
      </Col>
    )
  })

  return (
    <section
      className={`${styles.element} section-break-out section-break-out-no-margins-mobile large-area-element`}
    >
      <div className="container">
        <Row className="mobile-bottom-margins narrow-bottom-margins">
          {tableFormatted}
        </Row>
      </div>
    </section>
  )
}

export default PricingTables
